import Cookies from 'js-cookie';

export function getGBSessionId(): string {
  const cookieName = 'fc-gb-session-id';
  const sessionId = Cookies.get(cookieName);

  return sessionId;
}

export async function waitForSessionId(getSessionId: () => string | undefined, maxTries = 5, delayMs = 200): Promise<string | undefined> {
  let tries = 0;
  while (tries < maxTries) {
    const sessionId = getSessionId();
    if (sessionId) return sessionId;
    tries += 1;
    // eslint-disable-next-line no-await-in-loop
    await new Promise(resolve => setTimeout(resolve, delayMs));
  }
  return undefined;
}
